export default __webpack_public_path__ + "static/media/spaceExplorer.47e5b541.gif";